import HandymanSchedule from "../../components/handyman/schedule/schedule";

const SchedulePage = () => {
  return <HandymanSchedule />;
};

export default SchedulePage;
